import React, { useCallback, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { setAppError } from "./../../../../../store/userSlice";
import { FaFilePdf } from "react-icons/fa";
import ApplyDateUpdate from "./ApplyDateUpdate";
import nodeinstance from "../../../../../nodeInstance";
import DocumentsDownloadPopup from "../IqamaRenewList/popups/DocumentsDownloadPopup";
import DocumentUploadFilePopUp_Muqeem from "../FileDocumentPopUp/fileUploadMuqeem";
import SmartDownloadPagination from "../../../../../components/SmartDataTable/SmartDownloadPagination";

export default function ListPhysicalCardList({
  token,
  setTrigger: parentSetTrigger,
  trigger: parentTrigger,
  updateData,
}) {
  const [Popup, setPopUp] = useState(false);
  const [PopupDoc, setPopUpDoc] = useState(false);
  const [documentPopUp, setDocumentPopUp] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [document, setdocument] = useState([]);
  const [empData, setEmpData] = useState({});
  const [expiryFilter, setExpiryFilter] = useState("");
  const [trigger, setLocalTrigger] = useState(false);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const [searchData, setSearchData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const columns = useMemo(() => [
    { key: "sno", title: "S.NO.", sortable: false },
    { key: "selection", title: "SELECT", sortable: false },
    { key: "emp_id", title: "EMPLOYEE ID" },
    { key: "iqama_number", title: "IQAMA NUMBER" },
    { key: "iqama_received_date", title: "IQAMA RECEIVED DATE" },
    { key: "iqama_issue_date", title: "IQAMA ISSUE DATE (G)" },
    { key: "iqama_expiry_date_g", title: "IQAMA EXPIRY DATE (G)" },
    { key: "iqama_expiry_date_h", title: "IQAMA EXPIRY DATE (H)" },
    { key: "iqama_aging_days", title: "AGING DAYS" },
    { key: "issue_category", title: "ISSUE CATEGORY" },
    { key: "card_apply_date", title: "CARD APPLY DATE" },
    { key: "card_received_date", title: "CARD RECEIVED DATE" },
    { key: "physical_card_instance", title: "INSTANCE" },
    { key: "physical_card_status", title: "CARD STATUS" },
    { key: "action", title: "ACTION" },
  ], []);

  const handleStandaloneSearch = async (term) => {
    if (!term) return;
    setIsLoading(true);
    setIsSearchActive(true);
    try {
      const response = await nodeinstance.get(
        `/iqama/iqammaDoneSearchMuqeem/Muqeem/${term}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      if (response.data) {
        setSearchData(response.data.data || []);
      }
    } catch (error) {
      dispatch(setAppError({ msg: "Search failed: " + error.message }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (!value) {
      setIsSearchActive(false);
      setSearchData(null);
    }
  };

  const handleSelectionChange = useCallback((emp_id, isChecked, row) => {
    setSelectedIds((prev) => {
      if (isChecked) return [...prev, emp_id];
      return prev.filter((id) => id !== emp_id);
    });
    setSelectedRows((prev) => {
      if (isChecked) return [...prev, row];
      return prev.filter((r) => r.emp_id !== emp_id);
    });
  }, []);

  const downloadDocumentPopUp = (listDocument, row) => {
    setdocument(listDocument);
    setEmpData(row);
    setDocumentPopUp(true);
  };

  const updateStatusApi = async (data) => {
    try {
      const res = await nodeinstance.post("/iqama/updatestatus", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status === 200) {
        dispatch(setAppError({ msg: res?.data?.message, color: "success" }));
        setSelectedIds([]);
        setSelectedRows([]);
        setTrigger();
      }
    } catch (error) {
      dispatch(setAppError({ msg: error.message }));
    }
  };

  const renderCustomCell = (item, column) => {
    if (column.key === "selection") {
      if (item.card_status === "Physical Card Recived") {
        return (
          <button
            className="p-1 px-2 rounded-md bg-red text-white text-xs"
            onClick={() => setPopUpDoc(true)}
          >
            UPLOAD
          </button>
        );
      }
      return (
        <input
          type="checkbox"
          checked={selectedIds.includes(item.emp_id)}
          onChange={(e) => handleSelectionChange(item.emp_id, e.target.checked, item)}
          disabled={
            parseInt(item.iqama_aging_days) < 0 ||
            (item.physicalDocumentsList?.length !== 0 &&
              item.nakal_kafala_Iqamma === "Pending" &&
              item.visa_profession_Iqamma === "Pending")
          }
        />
      );
    }
    if (column.key === "action") {
      if (!item.physicalDocumentsList || item.physicalDocumentsList.length === 0) return "-";
      return (
        <button
          className="p-1"
          onClick={() => downloadDocumentPopUp(item.physicalDocumentsList, item)}
        >
          <FaFilePdf size={"1.4rem"} color="red" />
        </button>
      );
    }
    return null;
  };

  const PopOpen = (isApply) => {
    if (selectedIds.length === 0) {
      dispatch(setAppError({ msg: "Please select Check box" }));
      return;
    }

    if (isApply) {
      const alreadyApplied = selectedRows.filter(row => row.card_apply_date !== null);
      if (alreadyApplied.length > 0) {
        dispatch(setAppError({ msg: "Already applied for some selected users" }));
      } else {
        setPopUp(true);
      }
    } else {
      const missingApplyDate = selectedRows.filter(row => row.card_apply_date === null);
      if (missingApplyDate.length > 0) {
        dispatch(setAppError({ msg: "Card apply date is required for all selected employees" }));
      } else {
        updateStatusApi(
          selectedRows.map((t) => ({
            employee_id: t.emp_id,
            card_status: t.card_status,
          }))
        );
      }
    }
  };

  const setTrigger = () => {
    setLocalTrigger(prev => !prev);
    if (parentSetTrigger) parentSetTrigger(prev => !prev);
  };

  const apiEndpoint = useMemo(() => {
    const params = new URLSearchParams();
    if (expiryFilter) params.append("iqama_aging_days", expiryFilter);
    return `/iqama/iqammaDone/Physical?${params.toString()}`;
  }, [expiryFilter]);

  const additionalActions = useMemo(() => [
    {
      label: "upload File",
      onClick: () => setPopUpDoc(true),
      className: "p-2 px-4 rounded-md bg-red text-white text-xs"
    },
    {
      label: "2. Card Received Status",
      onClick: () => PopOpen(false),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "1. Apply physical Card",
      onClick: () => PopOpen(true),
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    },
    {
      label: "Clear filter",
      onClick: () => {
        setExpiryFilter("");
        setIsSearchActive(false);
        setSearchData(null);
      },
      className: "p-2 px-4 rounded-md bg-blue text-white text-sm"
    }
  ], [selectedIds, selectedRows]);

  const headerLeft = (
    <div className="flex gap-2 justify-end items-center whitespace-nowrap">
      <select
        className="select select-sm select-bordered uppercase h-10 w-48"
        value={expiryFilter}
        onChange={(e) => setExpiryFilter(e.target.value)}
      >
        <option value=""> {"IQAMA AGING"}</option>
        <option value="180">180</option>
      </select>
    </div>
  );

  return (
    <>
      <div className="mt-4">
        <SmartDownloadPagination
          apiEndpoint="/iqama/iqammaDone/Physical"
          token={token}
          columns={columns}
          layoutType="table"
          additionalActions={additionalActions}
          headerLeft={headerLeft}
          renderCustomCell={renderCustomCell}
          searchPlaceholder={"Search employee id..."}
          defaultPageSize={50}
          pageSizeOptions={[10, 50, 100, 500, 1000]}
          trigger={trigger || parentTrigger}
          onSearchClick={handleStandaloneSearch}
          onSearchChange={handleSearchChange}
          manualData={isSearchActive ? searchData : null}
          enableDownload={false}
        />
      </div>

      {Popup && (
        <ApplyDateUpdate
          title={"Apply Physical Card"}
          token={token}
          list={selectedRows.filter(row => row.card_apply_date === null)}
          PopUp={Popup}
          setPopUp={setPopUp}
          url={"/iqama/update"}
          callBack={() => {
            setTrigger();
            if (updateData) updateData();
          }}
        />
      )}

      {documentPopUp && (
        <DocumentsDownloadPopup
          empData={empData}
          PopUp={documentPopUp}
          setPopUp={setDocumentPopUp}
          title={"Upload Border Number"}
          url={"/iqama/updatestatus"}
          list={document}
        />
      )}

      {PopupDoc && (
        <DocumentUploadFilePopUp_Muqeem
          PopUp={PopupDoc}
          setPopUp={setPopUpDoc}
          title={"UPLOAD Bulk Documents"}
          url={`/iqama/bulkuploadPhysicalDoc/`}
          fileFormat={">  physical-card-IQAMA NUMBER"}
          fileNme={">  physical-card-IQAMA NUMBER"}
          setTrigger={setTrigger}
          trigger={trigger}
        />
      )}
    </>
  );
}
